/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDetailsContextResponse
 */
export interface UserDetailsContextResponse {
    /**
     * Whether the user has to provide a phone number for this signup.
     * @type {boolean}
     * @memberof UserDetailsContextResponse
     */
    phoneNumberMandatory: boolean;
}

/**
 * Check if a given object implements the UserDetailsContextResponse interface.
 */
export function instanceOfUserDetailsContextResponse(value: object): value is UserDetailsContextResponse {
    if (!('phoneNumberMandatory' in value) || value['phoneNumberMandatory'] === undefined) return false;
    return true;
}

export function UserDetailsContextResponseFromJSON(json: any): UserDetailsContextResponse {
    return UserDetailsContextResponseFromJSONTyped(json, false);
}

export function UserDetailsContextResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDetailsContextResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'phoneNumberMandatory': json['phoneNumberMandatory'],
    };
}

export function UserDetailsContextResponseToJSON(value?: UserDetailsContextResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'phoneNumberMandatory': value['phoneNumberMandatory'],
    };
}

